import { Button, EditableText } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as R from 'ramda'
import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch, RootState, select, store } from '../../store'
import buttonStyles from '../Button/button.scss'
import dragStyles from '../Drag/drag.scss'
import Icon from '../Icon'
import MaterialItem from '../MaterialItem'
import styles from './insight.scss'

const cx = classnames.bind({ ...styles, ...buttonStyles, ...dragStyles })

interface IInsightProps
  extends ReturnType<typeof mapState>,
    ReturnType<typeof mapDispatch> {
  insightId: string
  lectureId: string
  onDelete: () => void
  activeMaterialIdx: number
  scrollToElement: () => void
  currentLecture: ILecture | null
}

interface IInsightState {
  editing: boolean
  expanded: {
    [idx: number]: boolean;
  }
}

const ViewContent = ({
  currentLecture,
  expanded,
  scrollToElement,
  lectureId,
  insightId,
  onEdit,
  onDelete,
  onMaterialReply,
  onMaterialReactionToggle,
  onMaterialStarted,
  onMaterialEnded,
  onMaterialExpand,
  activeMaterialIdx
}: IInsightProps & {
  expanded: { [idx: number]: boolean };
  onEdit: () => void;
  onMaterialExpand: (materialIdx: number) => void;
  scrollToElement: (
    ref: any,
    insightId: string,
    activeMaterialIdx: number
  ) => void;
}) => {
  const rootState = store.getState()
  const insight = select.insights.getById(rootState, insightId)
  const lecture = select.lectures.getById(rootState, lectureId)
  const currentUser = firebase.auth().currentUser
  const isSpeaker =
    lecture !== null &&
    currentUser !== null &&
    R.contains(currentUser.uid, lecture.speakerIds)
  return (
    <div>
      <h4 className={cx('message-item', 'insight-title')}>
        {isSpeaker ? (
          <span>
            <Button icon="edit" onClick={onEdit} />
            &nbsp;
            <Button icon="trash" onClick={onDelete} />
            &nbsp;
          </span>
        ) : null}
        <span>{insight ? insight.text : '觀點讀取中'}</span>
      </h4>
      {insight
        ? insight.materials.map((material, materialIdx) => (
            <MaterialItem
              ref={ref => {
                if (materialIdx === activeMaterialIdx) {
                  scrollToElement(ref, insightId, activeMaterialIdx)
                }
              }}
              id={`mat-${insightId}-${materialIdx}`}
              key={`${insightId}-${material.name}-${material.downloadUrl}`}
              expanded={expanded[materialIdx]}
              currentLecture={currentLecture}
              lectureId={lectureId}
              insightId={insightId}
              materialIdx={materialIdx}
              editable={false}
              material={material}
              onExpand={onMaterialExpand.bind(null, materialIdx)}
              onReply={onMaterialReply.bind(null, materialIdx)}
              onReactionToggle={onMaterialReactionToggle.bind(
                null,
                materialIdx
              )}
              onStarted={onMaterialStarted.bind(null, materialIdx)}
              onEnded={onMaterialEnded.bind(null, materialIdx)}
            />
          ))
        : '教材讀取中'}
    </div>
  )
}

const EditContent = ({
  lectureId,
  insightId,
  onConfirm,
  currentLecture,
  onMaterialAddClick,
  onInsightTextSave,
  onMaterialConfirm,
  onMaterialDelete
}: IInsightProps & {
  onConfirm: () => void;
  scrollToElement: (
    ref: any,
    insightId: string,
    activeMaterialIdx: number
  ) => void;
}) => {
  const insight = select.insights.getById(store.getState(), insightId)
  return (
    <div className={cx('drag-item', 'drag-item--edit')}>
      <h4>
        {// TODO: styling here
        /* <input className={cx('drag-item__input')} type="text" placeholder="請輸入標題(非必填)" /> */
        insight ? (
          <EditableText
            onConfirm={onInsightTextSave}
            defaultValue={insight.text}
          />
        ) : (
          <h5>N/A</h5>
        )}
      </h4>
      <br />
      {insight
        ? insight.materials.map((material, materialIdx) => (
            <MaterialItem
              id={`mat-${insightId}-${materialIdx}`}
              key={`${insightId}-${material.name}-${material.downloadUrl}`}
              expanded={false}
              currentLecture={currentLecture}
              lectureId={lectureId}
              insightId={insightId}
              materialIdx={materialIdx}
              onConfirm={onMaterialConfirm.bind(null, materialIdx)}
              onDelete={onMaterialDelete.bind(null, materialIdx)}
              editable={true}
              material={material}
            />
          ))
        : '教材讀取中'}
      <div className={cx('drag-item__edit-btns')}>
        <span>
          <Button
            icon="record"
            onClick={onMaterialAddClick.bind(null, 'audio')}
          />
        </span>
        <span>
          <Button
            icon="media"
            onClick={onMaterialAddClick.bind(null, 'image')}
          />
        </span>
        <span>
          <Button icon="link" onClick={onMaterialAddClick.bind(null, 'text')} />
        </span>
        <button
          title="確認"
          onClick={onConfirm}
          className={cx('drag-item__comfirm-btn')}
        >
          <Icon type="lecture-droptop" />
          確認
        </button>
      </div>
    </div>
  )
}

class Insight extends React.PureComponent<IInsightProps, IInsightState> {
  public materials = []

  public state = {
    editing: false,
    expanded: {}
  }
  public handleEditingToggle = () => {
    this.setState({ editing: !this.state.editing })
  }
  public handleMaterialExpand = (materialIdx: number) => {
    this.setState({
      expanded: { [materialIdx]: !this.state.expanded[materialIdx] }
    })
  }
  public componentDidMount = () => {
    this.props.onFetchInsight()
    this.setState({
      expanded: {
        [this.props.activeMaterialIdx]: true
      }
    })
  }
  public componentWillReceiveProps = (nextProps: IInsightProps) => {
    this.setState({
      expanded: {
        [nextProps.activeMaterialIdx]: true
      }
    })
  }
  public render() {
    const { editing, expanded } = this.state
    // const speaker = insight ? select.users.getById(store.getState(), insight.speakerId) : null
    return editing ? (
      <EditContent
        {...this.props}
        scrollToElement={this.props.scrollToElement}
        onConfirm={this.handleEditingToggle}
      />
    ) : (
      <ViewContent
        {...this.props}
        scrollToElement={this.props.scrollToElement}
        onEdit={this.handleEditingToggle}
        expanded={expanded}
        onMaterialExpand={this.handleMaterialExpand}
      />
    )
  }
}
// const mapRef = () => ({ withRef: true })

const mapState = ({ insights, users, lectureContent }: RootState) => ({
  insights,
  users,
  ...lectureContent
})

const mapDispatch = (dispatch: Dispatch, ownProps: any) => {
  const { insightId, lectureId } = ownProps as IInsightProps
  return {
    onMaterialConfirm: (materialIdx: number, updatedMaterial: IMaterial) => {
      const insight = select.insights.getById(store.getState(), insightId)
      if (insight === null) {
        throw Error('no insight')
      }
      dispatch.insights.updateInsight({
        insightId,
        updated: {
          materials: [
            ...insight.materials.slice(0, materialIdx),
            updatedMaterial,
            ...insight.materials.slice(materialIdx + 1)
          ]
        }
      })
    },
    onMaterialDelete: (materialIdx: number) => {
      const insight = select.insights.getById(store.getState(), insightId)
      if (insight === null) {
        throw Error('no insight')
      }
      dispatch.insights.updateInsight({
        insightId,
        updated: {
          materials: [
            ...insight.materials.slice(0, materialIdx),
            ...insight.materials.slice(materialIdx + 1)
          ]
        }
      })
    },
    onMaterialReactionToggle: (materialIdx: number) => {
      dispatch.insights
        .toggleReaction({
          lectureId,
          chapterIdx: -1,
          insightId,
          materialIdx,
          reaction: 'like'
        })
        .catch((error: Error) => {
          alert('登入後才可參與～')
        })
    },
    onMaterialReply: (materialIdx: number, reply: IReply) => {
      dispatch.insights
        .addReply({
          insightId,
          chapterIdx: -1,
          materialIdx,
          reply,
          lectureId
        })
        .catch((error: Error) => {
          alert('登入後才可參與～')
        })
    },
    onMaterialAddClick: (contentType: string) => {
      const material: IMaterial = {
        name: '',
        downloadUrl: null,
        metadata: {
          contentType
        },
        replyIds: [],
        reactions: {
          like: []
        }
      }
      dispatch.insights.addMaterial({ insightId, material })
    },
    onMaterialStarted: (materialIdx: number) => {
      // dispatch.lectureContent.changeCurrentMaterial(materialIdx)
    },
    onMaterialEnded: (materialIdx: number) => {
      // dispatch.lectureContent.nextMaterial()
    },
    onInsightTextSave: (text: string) => {
      const savedText = text === '' ? '未命名區塊' : text
      dispatch.insights.updateInsight({
        insightId,
        updated: { text: savedText }
      })
    },
    onFetchInsight: () => {
      const insight = select.insights.getById(store.getState(), insightId)
      if (!insight) {
        dispatch.insights.fetchInsights([insightId])
      }
    }
  }
}

export default connect(
  mapState,
  mapDispatch
)(Insight)



// WEBPACK FOOTER //
// ./src/components/InsightItem/index.tsx